export default __webpack_public_path__ + "91f4534a2ecbd2a307fd5948867f49e8.png";